var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdjustFanIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z",
    fill: "#F0FDFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 26.3333C20.8778 26.4917 21.1237 26.5977 21.3839 26.6425C21.6442 26.6872 21.9114 26.6695 22.1635 26.5908C22.4155 26.512 22.6453 26.3745 22.8338 26.1896C23.0223 26.0046 23.1641 25.7775 23.2476 25.527C23.3312 25.2764 23.3539 25.0096 23.3141 24.7486C23.2743 24.4875 23.173 24.2396 23.0186 24.0254C22.8642 23.8112 22.661 23.6367 22.426 23.5163C22.1909 23.396 21.9306 23.3333 21.6665 23.3333H11.6665",
    stroke: "#009689",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5832 16.6666C24.7962 16.3825 25.0784 16.1576 25.4028 16.0132C25.7273 15.8688 26.0832 15.8098 26.4369 15.8417C26.7906 15.8736 27.1303 15.9953 27.4237 16.1954C27.717 16.3955 27.9544 16.6673 28.1132 16.9849C28.272 17.3025 28.347 17.6555 28.3311 18.0102C28.3151 18.365 28.2087 18.7098 28.022 19.0119C27.8353 19.3139 27.5745 19.5633 27.2643 19.7362C26.9542 19.9091 26.605 19.9999 26.2498 19.9999H11.6665",
    stroke: "#009689",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1665 13.6666C18.3778 13.5081 18.6237 13.4022 18.8839 13.3574C19.1442 13.3126 19.4114 13.3303 19.6635 13.4091C19.9155 13.4878 20.1453 13.6253 20.3338 13.8103C20.5223 13.9952 20.6641 14.2223 20.7476 14.4729C20.8312 14.7234 20.8539 14.9902 20.8141 15.2513C20.7743 15.5123 20.673 15.7602 20.5186 15.9744C20.3642 16.1887 20.161 16.3632 19.926 16.4835C19.6909 16.6038 19.4306 16.6666 19.1665 16.6666H11.6665",
    stroke: "#009689",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustFanIcon);
export default __webpack_public_path__ + "static/media/adjust_fan_icon.a06d27b5e048c66e8cdb808636fc3d0c.svg";
export { ForwardRef as ReactComponent };